export const eventsPlayer = [
    "canplay",
    "waiting",
    "ended",
    "pause",
    "playing"
];

export const unsupportedTextTrackIds = [
    'SERVICE1'
];

export const unsupportedTextTrackKinds = [
    'metadata'
];
